import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-8">
      <div className="container mx-auto px-6 text-center">
        <p className="text-gray-400">
          © 2025 Prince Emma Ejikeme. Built with React.
        </p>
      </div>
    </footer>
  );
};

export default Footer;